import { render, staticRenderFns } from "./serve-dialog.vue?vue&type=template&id=288935bf&scoped=true"
import script from "./serve-dialog.vue?vue&type=script&lang=js"
export * from "./serve-dialog.vue?vue&type=script&lang=js"
import style0 from "./serve-dialog.vue?vue&type=style&index=0&id=288935bf&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "288935bf",
  null
  
)

export default component.exports